import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'components';
import { ProtectedPrivateContainer } from 'modules';

import HeaderSelect from '../common/HeaderSelect';

import { useUserMenuOptions } from './hooks/useUserMenuOptions';
import useAppSelector from 'hooks/redux/useAppSelector';

import { publicUrls } from 'constants/urls';

const UserMenu = () => {
  const { t } = useTranslation();
  const { user } = useAppSelector(state => state.user);

  const userMenuOptions = useUserMenuOptions();

  return (
    <ProtectedPrivateContainer
      fallback={
        <NavLink to={publicUrls.login} className="np-header__navigation-menu-link">
          <Button type="default" size="small" color="primary">
            {t('form.button.logIn')}
          </Button>
        </NavLink>
      }
    >
      <HeaderSelect title={user?.username} items={userMenuOptions} />
    </ProtectedPrivateContainer>
  );
};

export default UserMenu;
